(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roar-application-details"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('roar-application-tabs')) {
    customElements.define('roar-application-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.select = (id, focus = false) => {
          const tab = this.tabs.find(item => item.dataset.app === id);
          if (!tab) return false;
          this.querySelectorAll('video').forEach(video => video.pause());
          this.tabs.forEach(item => { item.setAttribute('aria-selected', String(item === tab)); item.tabIndex = item === tab ? 0 : -1; });
          this.panels.forEach(panel => panel.hidden = panel.id !== id);
          if (focus) tab.focus();
          return true;
        };
        this.onHash = () => {
          const id = window.location.hash.slice(1);
          if (this.select(id)) requestAnimationFrame(() => this.closest('section').scrollIntoView({block: 'start'}));
        };
        this.addEventListener('click', event => {
          const tab = event.target.closest('[role="tab"]');
          if (!tab) return;
          this.select(tab.dataset.app);
          history.replaceState(null, '', '#' + tab.dataset.app);
        });
        this.addEventListener('keydown', event => {
          const index = this.tabs.indexOf(event.target);
          if (index < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.select(this.tabs[next].dataset.app, true);
        });
        window.addEventListener('hashchange', this.onHash);
        this.onHash();
      }
      disconnectedCallback() { window.removeEventListener('hashchange', this.onHash); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roar-help"] && !Shopify.designMode) return;
  try {
    
function initRoarHelp(root){
 root.querySelectorAll('[data-roar-video-help]').forEach(hub=>{
  if(hub.dataset.ready)return;hub.dataset.ready='true';
  const panels=[...hub.querySelectorAll('[data-help-panel]')];
  const buttons=[...hub.querySelectorAll('[data-help-select]')];
  buttons.forEach(button=>button.addEventListener('click',()=>{
   panels.forEach(panel=>{const active=panel.id===button.getAttribute('aria-controls');if(!active)panel.querySelector('video')?.pause();panel.hidden=!active;});
   buttons.forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
   if(window.matchMedia('(max-width:650px)').matches)hub.querySelector('[data-help-panel]:not([hidden])')?.scrollIntoView({behavior:'smooth',block:'start'});
  }));
  hub.querySelectorAll('[data-help-play]').forEach(button=>button.addEventListener('click',()=>{const video=button.closest('[data-help-panel]').querySelector('video');if(video){video.play().catch(()=>{});video.focus();}}));
  panels.forEach(panel=>{const video=panel.querySelector('video');if(video)video.addEventListener('play',()=>{panels.forEach(other=>{if(other!==panel)other.querySelector('video')?.pause();});});});
 });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>initRoarHelp(document));}else{initRoarHelp(document);}
document.addEventListener('shopify:section:load',event=>initRoarHelp(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roar-product"]) return;
  try {
    
  if (!customElements.get('roar-order-summary')) {
    customElements.define('roar-order-summary', class extends HTMLElement {
      connectedCallback() {
        this.quantityInput = document.getElementById(this.dataset.input);
        if (!this.quantityInput) return;
        this.updateSummary = () => {
          const quantity = this.quantityInput.valueAsNumber;
          if (!Number.isSafeInteger(quantity) || quantity < 1) return;
          const locale = this.dataset.locale === 'es' ? 'es-MX' : this.dataset.locale || 'es-MX';
          const number = new Intl.NumberFormat(locale);
          const money = new Intl.NumberFormat(locale, {style: 'currency', currency: this.dataset.currency || 'MXN', currencyDisplay: 'code'});
          this.querySelector('[data-roar-packages]').textContent = number.format(quantity);
          this.querySelector('[data-roar-kg]').textContent = number.format(quantity * Number(this.dataset.kg));
          const pieces = this.querySelector('[data-roar-pieces]');
          if (pieces) pieces.textContent = number.format(quantity * Number(this.dataset.pieces));
          this.querySelector('[data-roar-subtotal]').textContent = money.format(quantity * Number(this.dataset.price) / 100);
        };
        this.quantityInput.addEventListener('input', this.updateSummary);
        this.quantityInput.addEventListener('change', this.updateSummary);
        this.updateSummary();
      }
      disconnectedCallback() {
        if (!this.quantityInput) return;
        this.quantityInput.removeEventListener('input', this.updateSummary);
        this.quantityInput.removeEventListener('change', this.updateSummary);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
